import { AfterViewInit, Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-panel-box',
  templateUrl: './panel-box.component.html',
  styleUrls: ['./panel-box.component.scss']
})
export class PanelBoxComponent implements OnInit, AfterViewInit {

  @Input() set config(data) {
    this.configObj = { ...data };
  }
  @Input() bodyTemplate: TemplateRef<any>;
  @Input() itemSelectedTemplate: TemplateRef<any>;
  @ViewChild('collapse') collapse: any;
  @ViewChild('panel') panel: any;
  @ViewChild('toggleArrow') toggleArrow: any;
  configObj: IPanelConfig;
  toggle = false;
  wasInside = false;
  constructor() {}

  ngOnInit(): void { }

  onClick(): void {
    const panelBox = this.panel.nativeElement;
    const height = this.configObj?.height || 90;
    panelBox.style.height = panelBox.style.height ? null : height + '%';
    this.toggle = !this.toggle;
  }

  ngAfterViewInit(): void {
    if (this.configObj?.expanded) {
      setTimeout(()=> {
        this.onClick();
      }, 500)
    }
  }
}
export interface IPanelConfig {
  title: string;
  height: number;
  expanded: boolean;
  position: string;
  itemSelected?: object;
}
